import React from 'react';
import i18next from 'i18next';
import { string } from 'prop-types';
import CheckIcon from '@mui/icons-material/Check';

function BillingRow({ text, value, style }) {
  const isBillingType = text === 'billingType';
  const isDocumentType = text === 'documentType';
  const isTaxFree = text === 'taxFree';

  return (
    <div className="row middle m-top-1">
      {!isTaxFree ? (
        <div className={style}>
          <span className="bold font-size-14">{i18next.t(`OrdersDetails:${text}`)}</span>
        </div>
      ) : null}
      <div>
        <span className="font-size-14">
          {isTaxFree ? (
            <div className="row middle">
              <CheckIcon style={{ color: '#4caf50', marginRight: '8px', fontSize: '20px' }} />
              {i18next.t(`OrdersDetails:${text}`)}
            </div>
          ) : isDocumentType || isBillingType ? (
            i18next.t(`OrdersDetails:${value}`)
          ) : (
            value
          )}
        </span>
      </div>
    </div>
  );
}

BillingRow.propTypes = {
  style: string.isRequired,
  text: string.isRequired,
  value: string.isRequired
};

export default BillingRow;
